export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  // Le nouveau service worker supprime lui-même les anciens caches (voir public/sw.js).
  // On ne désinstalle plus à chaque chargement : sinon le mode hors ligne ne peut pas fonctionner.
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/sw.js').then(function (reg) {
      if (reg && reg.update) reg.update();
    }).catch(function () {});
  });
}
